<div class="folder-files-container">
    <div class="folder-files-container-left">
        <div class="search-create-folder-container">
            <div class="input-container-search">
                <input type="text" placeholder="Search folder" class="input-search-folder" (input)="filterFolders($event)" />
                <img src="assets/Deep-CV/search.png" alt="search" class="img-small img-search" /> 
            </div>
            <button  (click)="addingFolder = !addingFolder" class="conectio-rectangular-small-add">
                <img src="assets/Deep-CV/more-icon.png" alt="Add" class="img-small" />
            </button>
        </div>
        <form [formGroup]="newFolderForm" *ngIf="addingFolder">
            <div class="folders-container-adding-folder" *ngIf="addingFolder">
                <input type="text" class="input-search-folder input-full-width" placeholder="Nombre de la carpeta" formControlName="name" />    
                <button type="button" class="folder-edit-btn confirm" (click)="addFolder()" [disabled]="loading">
                    <span *ngIf="!loading">&#10003;</span>
                    <img *ngIf="loading" src="assets/spinner.gif" alt="Saving" class="img-tiny" />
                </button>
            </div>
        </form>


        <div class="folders-container">
            <div class="folders-container-loading" *ngIf="loadingFolders">
                <img src="assets/spinner.gif" alt="Loading" class="img-big" />
            </div>
            <div *ngFor="let item of folders | keyvalue | orderKeyValueByDate">
                <div class="folder-item-date" *ngIf="item.value.length > 0">
                    <span>{{ item.key }}</span>
                </div>
                <div class="folder-item" *ngFor="let folder of item.value" (click)="onFolderSelected(folder)" [class.selected-folder]="folderId === folder.id">
                    <div class="folder-name" [class.folder-name--editing]="editingFolderId === folder.id">
                        <ng-container *ngIf="editingFolderId !== folder.id; else editingFolderTpl">
                            <strong>{{ folder.name }}</strong>
                        </ng-container>
                        <ng-template #editingFolderTpl>
                            <input
                                type="text"
                                class="folder-edit-input"
                                [(ngModel)]="editingFolderName"
                                (click)="$event.stopPropagation()"
                                (keydown.enter)="saveFolderName(folder, $event)"
                                (keydown.escape)="cancelEditingFolder($event)"
                                placeholder="{{ 'CVDeepAnalyzer.CVDrive.renamePlaceholder' | translate }}"
                                title="{{ 'CVDeepAnalyzer.CVDrive.renamePlaceholder' | translate }}"
                                [disabled]="editingFolderSaving"
                            />
                            <div class="folder-edit-actions">
                                <button type="button" class="folder-edit-btn confirm" (click)="saveFolderName(folder, $event)" [disabled]="editingFolderSaving">
                                    <span *ngIf="!editingFolderSaving">&#10003;</span>
                                    <img *ngIf="editingFolderSaving" src="assets/spinner.gif" alt="Saving" class="img-tiny" />
                                </button>
                                <button type="button" class="folder-edit-btn cancel" (click)="cancelEditingFolder($event)" [disabled]="editingFolderSaving">
                                    &#10005;
                                </button>
                            </div>
                        </ng-template>
                    </div>
                    <div 
                        class="folder-points-menu-container folder-points-menu-trigger"
                        (mouseenter)="folder.showMenu = true" 
                        (mouseleave)="folder.showMenu = false" 
                    >
                        <img *ngIf="!folder.showMenu" src="assets/Deep-CV/3-points.png" alt="Add" class="img-small" />
                        <div 
                            *ngIf="folder.showMenu" 
                            class="folder-menu-btns"
                            
                        >
                            <button mat-icon-button type="button" (click)="startEditingFolder(folder, $event)"><img src="assets/Deep-CV/boton-editar.png" alt="Editar" class="img-auto-size" /></button>
                            <button mat-icon-button type="button" (click)="deleteFolder(folder.id, $event)"><img src="assets/Deep-CV/borrar.png" alt="Delete" class="img-auto-size" /></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="folder-files-container-right">
        <label class="cv-upload-dropzone" [class.disabled]="processingIndex >= 0 || !folderId" 
            (dragover)="onFileDragOver($event)"
            (dragleave)="onFileDragLeave($event)"
            (drop)="onFileDrop($event)"
            [class.drag-over]="isDragOver">
            <input type="file" class="cv-upload-input" (change)="onFileSelected($event)" multiple [disabled]="processingIndex >= 0 || !folderId" aria-label="Upload CV files" title="Upload CV files" />
            <div class="cv-upload-content" *ngIf="!(processingIndex >= 0 || !folderId)">
                <div class="cv-upload-icon">
                    <img src="assets/Deep-CV/upload-file-CV.png" alt="Upload" class="cv-upload-image" />
                    <span>{{ 'CVDeepAnalyzer.CVDrive.uploadCVButton' | translate }}</span> 
                </div>
                <p style="margin-bottom: 0px;">{{ 'CVDeepAnalyzer.CVDrive.uploadCVMessage' | translate }}</p>
            </div>
            <div class="cv-upload-content-loader" *ngIf="(processingIndex >= 0 || !folderId)">
                <img src="assets/spinner.gif" alt="Saving" class="loader-saving-icon" />
                <div>
                    <h3 *ngIf="allfilesuploaded.length == 1">{{ 'CVDeepAnalyzer.CVDrive.uploadingCVtitlesingular' | translate }}</h3>
                    <h3 *ngIf="allfilesuploaded.length > 1">{{ 'CVDeepAnalyzer.CVDrive.uploadingCVtitleplural' | translate: { total: allfilesuploaded.length } }}</h3>
                    <p *ngIf="calculateMinutesToAnalyze() == 1">{{ 'CVDeepAnalyzer.CVDrive.uploadingCVMessagesingular' | translate: { minutes: calculateMinutesToAnalyze() } }}</p>
                    <p *ngIf="calculateMinutesToAnalyze() > 1">{{ 'CVDeepAnalyzer.CVDrive.uploadingCVMessageplural' | translate: { minutes: calculateMinutesToAnalyze() } }}</p>
                </div>
            </div>
        </label>

        

        <div class="cv-upload-files-container-actions">
            <div class="cv-upload-files-container-actions-left">
                <div class="cv-upload-files-container-actions-left-item">
                    <span>{{ 'CVDeepAnalyzer.CVDrive.totalCV' | translate }}: <strong>{{ files.length }}</strong></span>
                </div>
                <div class="cv-upload-files-container-actions-left-item">
                    <span>{{ 'CVDeepAnalyzer.CVDrive.selectedCVs' | translate }}: <strong>{{ selectedFiles.length }}</strong></span> 
                </div>
                <div class="cv-upload-files-container-actions-left-item processing-info" *ngIf="processingIndex >= 0">
                    <img src="assets/spinner.gif" alt="Loading" class="img-small" />
                    <span>{{ 'CVDeepAnalyzer.CVDrive.processingCV' | translate }} ({{ processingIndex }} / {{ totalFiles }})...</span>
                </div>
                <div class="cv-upload-files-container-actions-left-item processing-info" *ngIf="loading">
                    <img src="assets/spinner.gif" alt="Loading" class="img-small" />
                    <span>{{ 'CVDeepAnalyzer.CVDrive.uploadingCV' | translate }}</span>
                </div>
            </div>
            <div class="cv-upload-files-container-actions-right">
                <button mat-button color="primary" class="select-all-cv-button" (click)="setAllSelectedCVs()" [ngClass]="{'selected-button': selectedFiles.length === files.length && selectedFiles.length > 0}">{{ 'CVDeepAnalyzer.CVDrive.selectAllCVs' | translate }}</button>
                <button mat-button color="primary" (click)="setselectedCVs()" [disabled]="savingSelectedCVs" *ngIf="is_new_analysis">
                    <span *ngIf="!savingSelectedCVs">{{ 'CVDeepAnalyzer.CVDrive.nextButton' | translate }}</span>
                    <img *ngIf="savingSelectedCVs" src="assets/spinner.gif" alt="Saving" class="img-tiny" />
                </button>
                <button mat-button color="primary" (click)="setselectedCVs()" [disabled]="savingSelectedCVs" *ngIf="!is_new_analysis && selectedFiles.length > saved_selected_files.length">
                    <span *ngIf="!savingSelectedCVs">{{ ('CVDeepAnalyzer.CVDrive.updateButton' | translate) }}</span>
                    <img *ngIf="savingSelectedCVs" src="assets/spinner.gif" alt="Saving" class="img-tiny" />
                </button>
            </div>
        </div>

        <div class="cv-upload-files-container-files">
            <div class="cv-upload-files-container-files-item" *ngFor="let CVFile of files" (click)="saveSelectedFile(CVFile.id)">
                <div class="folder-points-menu-container folder-points-menu-trigger" (mouseenter)="CVFile.showMenu = true"  (mouseleave)="CVFile.showMenu = false">
                    <img *ngIf="!CVFile.showMenu" src="assets/Deep-CV/3-points.png" alt="Add" class="img-small" />
                    <div *ngIf="CVFile.showMenu" class="folder-menu-btns">
                        <button mat-icon-button (click)="openJsonCv(CVFile.preprocessed_json, $event)"><img src="assets/Deep-CV/see.png" alt="Ver" class="img-auto-size" /></button>
                        <button mat-icon-button (click)="deleteFile(CVFile.id, $event)"><img src="assets/Deep-CV/borrar.png" alt="Delete" class="img-auto-size" /></button>
                    </div>
                </div>
                <img src="assets/Deep-CV/CV-image.png" alt="Upload" class="cv-upload-icon-image" />
                <span [class.selected-file]="selectedFiles.includes(CVFile.id)">{{ CVFile?.preprocessed_json?.name ? CVFile?.preprocessed_json?.name : CVFile?.file_name }}</span>
                
            </div>
            <div class="cv-upload-files-container-files-item-loading" *ngIf="loadingFiles">
                <img src="assets/spinner.gif" alt="Loading" class="img-big" />
            </div>
        </div>

    </div>
</div>